import { render } from "./PendingOrdersChart.vue?vue&type=template&id=0121e8f9&scoped=true&ts=true"
import script from "./PendingOrdersChart.vue?vue&type=script&lang=ts"
export * from "./PendingOrdersChart.vue?vue&type=script&lang=ts"

import "./PendingOrdersChart.vue?vue&type=style&index=0&id=0121e8f9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0121e8f9"]])

export default __exports__